'use client';

import { usePathname, useRouter } from 'next/navigation';
import { IconArrowRight1 } from '@/features/icons';
import { pageTitles } from '@/app/profile/orders/constants';
import { useCartReturnUrl } from '../cart/_utils/use-cart-return-url';
export default function OrderHeader() {
  const pathname = usePathname();
  const router = useRouter();
  const {
    returnUrl
  } = useCartReturnUrl();
  const goBack = () => {
    switch (pathname) {
      case '/cart':
        router.push(returnUrl || '/');
        break;
      case '/checkout/shipping':
        router.push('/cart');
        break;
      case '/checkout/payment':
        router.push('/checkout/shipping');
        break;
    }
  };
  const pageTitle = pageTitles[pathname] || '';
  return <div className='sticky top-0 z-[1001] mb-2 flex min-h-14 items-center justify-center bg-white px-4 py-3 shadow-sm lg:hidden' data-sentry-component="OrderHeader" data-sentry-source-file="header.tsx">
            <IconArrowRight1 className='absolute right-2 h-6 w-6 cursor-pointer text-text-black' onClick={goBack} data-sentry-element="IconArrowRight1" data-sentry-source-file="header.tsx" />
            <span className='mt-1 text-body-16 font-medium text-text-black'>{pageTitle}</span>
        </div>;
}